module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.db14160c.png";